/**
 * 提示词导出服务
 * 提供将提示词导出为JSON格式的功能
 */

/**
 * 导出单个提示词为JSON文件
 * @param {Object} prompt - 提示词对象
 */
export const exportPromptAsJson = (prompt) => {
  try {
    // 创建Blob对象
    const blob = new Blob([JSON.stringify(prompt, null, 2)], { type: 'application/json' });
    
    // 创建下载链接
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${prompt.title || '提示词'}.json`;
    
    // 触发下载
    document.body.appendChild(link);
    link.click();
    
    // 清理
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error('导出提示词失败:', error);
    return false;
  }
};

/**
 * 导出所有提示词为JSON文件
 * @param {Array} prompts - 提示词列表
 * @param {Array} folders - 文件夹列表，用于获取文件夹名称
 * @param {Array} tags - 标签列表，用于获取标签名称
 */
export const exportAllPromptsAsJson = (prompts, folders = [], tags = []) => {
  try {
    // 创建文件夹ID到名称的映射
    const folderMap = {};
    folders.forEach(folder => {
      folderMap[folder.id] = folder.name;
    });
    
    // 创建标签ID到名称的映射
    const tagMap = {};
    tags.forEach(tag => {
      tagMap[tag.id] = tag.name;
    });
    
    // 处理每个提示词，添加文件夹名称和标签名称
    const processedPrompts = prompts.map(prompt => {
      // 获取文件夹名称
      const folderName = prompt.folderId ? folderMap[prompt.folderId] || null : null;
      
      // 获取标签名称
      const tagNames = Array.isArray(prompt.tags) 
        ? prompt.tags.map(tagId => tagMap[tagId] || tagId).filter(Boolean)
        : [];
      
      // 返回处理后的提示词
      return {
        ...prompt,
        folderName,
        tagNames
      };
    });
    
    // 创建导出数据
    const exportData = {
      version: '1.0',
      exportedAt: new Date().toISOString(),
      count: processedPrompts.length,
      prompts: processedPrompts
    };
    
    // 创建Blob对象
    const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' });
    
    // 创建下载链接
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `提示词库_${new Date().toISOString().slice(0, 10)}.json`;
    
    // 触发下载
    document.body.appendChild(link);
    link.click();
    
    // 清理
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error('导出提示词失败:', error);
    return false;
  }
};

// 创建导出服务对象
const exportService = {
  exportPromptAsJson,
  exportAllPromptsAsJson
};

export default exportService;
